import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { WORLDS } from "../data/worlds";

const farben = WORLDS[0];

export const FirstWorld = () => (
  <section className="py-24 sm:py-32 overflow-hidden" id="lernwelten" data-testid="first-world-section">
    <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal className="relative order-2 lg:order-1">
        <div className="blob floaty-slow" style={{ background: "rgba(217,83,56,0.12)", width: "110%", height: "112%", top: "-6%", left: "-6%" }} />
        <div className="relative w-full max-w-[540px] mx-auto rounded-[18px] sm:rounded-[22px] overflow-hidden rotate-[-1.5deg]" style={{ boxShadow: "0 28px 60px rgba(44,43,40,0.2)" }}>
          <img src={farben.cover} alt="Das offizielle Buchcover von Kleine Welt, große Farben" className="w-full block" data-testid="first-world-cover" />
        </div>
        <span
          className="absolute -top-3 right-2 sm:right-6 text-[11px] font-semibold uppercase tracking-[0.14em] px-3.5 py-2 rounded-full text-white"
          style={{ background: "var(--gruen)" }}
        >
          {farben.age}
        </span>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <p className="eyebrow-label mb-5">Unsere erste Lernwelt</p>
          <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-3" data-testid="first-world-title">
            Kleine Welt,<br />große Farben
          </h2>
          <p className="font-display italic text-lg text-[color:var(--terra)] mb-7">{farben.subtitle}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed mb-8 space-y-4">
            <p className="font-display text-lg text-[color:var(--ink)]">
              Rot wie der Marienkäfer.<br />
              Blau wie der Wal.<br />
              Gelb wie das Küken.
            </p>
            <p>
              Kleine Welt, große Farben begleitet Kinder durch eine liebevoll gestaltete Welt der
              ersten Farben.
            </p>
          </div>
          <Link to="/lernwelten/farben" className="btn-primary" data-testid="first-world-cta">
            Lernwelt entdecken
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
